import { Kkconfig } from '../assets/js/config'

let _api = Kkconfig.reqUrl.dynApiUrl
let _static = Kkconfig.reqUrl.stApiUrl
let _img = Kkconfig.reqUrl.imgUrl
let _im = Kkconfig.reqUrl.imUrl

function getImg (route) {
  return _img + route
}

function getReportUrl (account) {
  let vueReturnUrl = window.location.protocol + '//' + window.location.host
  let reportUrl = _api + '/h5/report?vueReturnUrl=' + encodeURIComponent(vueReturnUrl)
  if (account != null) {
    let serviceUrl = _im + '?account=' + account
    reportUrl += '&serviceUrl=' + encodeURIComponent(serviceUrl)
  }
  return reportUrl
}

export { _api as APIBase, _static as StaticApiBase, _img as ImgHost, getImg, getReportUrl }
